import mutations from './emailTemplateEditor.mutations'
import actions from './emailTemplateEditor.actions'
import getters from './emailTemplateEditor.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
